import { create } from "zustand";
import ApiRequest from "./ApiRequest";
import Postmonger from "postmonger";
const session = new Postmonger.Session();

const useStore = create((set, get) => ({
  // ---------------------------------------------------------------------------
  // header 관련 상태 및 메서드
  // ---------------------------------------------------------------------------
  header: {
    // 기본 상수 및 UI 상태
    BASIC_ALERT_DURATION: 4000,
    imageModal: false,
    templateModal: false,
    resultModal: false,
    imageModalSelectMode: false,
    imageModalType: "all",
    disableImageModalType: false, // 이미지관리 모달 유형 선택 읽기전용 전환
    selectedSingleImageData: null,
    imageModalSubType: "",

    // 모달 제어 함수
    openModal: (modalName) =>
      set((state) => ({
        header: { ...state.header, [modalName]: true },
      })),
    closeModal: (modalName) =>
      set((state) => ({
        header: {
          ...state.header,
          [modalName]: false,
          imageModalSelectMode: false,
          imageModalType: "all",
          disableImageModalType: false,
          imageModalSubType: "",
        },
      })),
    setImageModalSelectMode: (flag) =>
      set((state) => ({
        header: { ...state.header, imageModalSelectMode: flag },
      })),
    setImageModalType: (type) =>
      set((state) => ({
        header: { ...state.header, imageModalType: type },
      })),
    setImageModalSubtype: (subType) =>
      set((state) => ({
        header: { ...state.header, imageModalSubType: subType },
      })),
    setDisableImageModalType: (flag) =>
      set((state) => ({
        header: { ...state.header, disableImageModalType: flag },
      })),
    setSelectedSingleImageData: (data) =>
      set((state) => ({
        header: { ...state.header, selectedSingleImageData: data },
      })),

    // Journey 및 Activity 관련
    journeyType: "",
    setJourneyType: (data) =>
      set((state) => ({
        header: { ...state.header, journeyType: data },
      })),
    actId: "",
    setActId: (data) =>
      set((state) => ({
        header: { ...state.header, actId: data },
      })),
    journeyId: "",
    setJourneyId: (data) =>
      set((state) => ({
        header: { ...state.header, journeyId: data },
      })),
    interactionId: "",
    setInteractionId: (data) =>
      set((state) => ({
        header: { ...state.header, interactionId: data },
      })),
    eventId: "",
    setEventId: (data) =>
      set((state) => ({
        header: { ...state.header, eventId: data },
      })),
    initActivity: {
        arguments: {
        execute: {
          inArguments: []
        }
      }

    },
    setInitActivity: (data) =>
      set((state) => ({
        header: { ...state.header, initActivity: data },
      })),

    // 로딩, 스피너 등 UI 상태
    loadingModal: false,
    onLoading() {
      set((state) => ({
        header: { ...state.header, loadingModal: true },
      }));
    },
    offLoading() {
      set((state) => ({
        header: { ...state.header, loadingModal: false },
      }));
    },
    isSpinner: false,
    setIsSpinner: (data) =>
      set((state) => ({
        header: { ...state.header, isSpinner: data },
      })),

    // 조직, 인증, 토큰 등
    org: {},
    token: "",
    extensionId: "",
    getAuth: async (eid, mid) => {
      console.log("getAuth called", { eid, mid });
      const url = "https://mcbh8y7162xy23b8-j6z-vpw1m68";
      const token_res = await ApiRequest.post("/channel/getTokens", {
        url,
        clientId: "vywgft5cyz8l88rhndww0b1m",
        secretKey: "G07jOQPxOo9j1NxM76I3t9LV",
        mid,
        mid,
      });
      console.log("token_res:", token_res);
      if (token_res.access_token) {
        set((state) => ({
          header: { ...state.header, token: token_res.access_token, org: { ...state.header.org, baseUrl: token_res.rest_instance_url.replace("https://", "") } },
        }));
      }
      console.log("get().header.eventId:", get().header.eventId);
      const extension_res = await ApiRequest.post("/channel/getDataExtension", {
        id: get().header.eventId,
        url,
        token: token_res.access_token,
      });
      console.log("extension_res:", extension_res);
      if (extension_res.dataExtensionId) {
        set((state) => ({
          header: {
            ...state.header,
            extensionId: extension_res.dataExtensionId,
          },
        }));
      }
    },

    // 데이터 조회: 이미지, 템플릿, 채널, 로그
    images: [],
    getImages: async function () {
      const { onLoading, offLoading } = get().header;
      onLoading.call(this);
      const query = "SELECT * FROM image";
      const res = await ApiRequest.post("/db/fetchData", { query });
      if (res.recordset.length > 0) {
        set((state) => ({
          header: { ...state.header, images: res.recordset },
        }));
      }
      offLoading.call(this);
    },

    templates: [],
    getTemplates: async function (channelName) {
      console.log("getTemplates called");
      const { onLoading, offLoading } = get().header;
      onLoading.call(this);
      let query = "SELECT * FROM no_message";
      const params = {};
      if (["DBU", "RBU", "OBU"].includes(channelName)) {
        query = `
          SELECT 
            msg_no, msg_gbn, msg_tmp_no, msg_target_gbn, msg_desc, 
            msg_img_seq, msg_img_url, msg_img_link_url, msg_btn_yn, 
            msg_reserve_dt, msg_send_yn, msg_send_cnt, msg_send_dt, 
            msg_reg_lg_no, msg_reg_ip, msg_reg_dt, msg_up_dt, msg_del_yn,
            msg_save_yn
          FROM no_message
        `;
        params.channelName = channelName;
      }
      console.log("getTemplates query:", query);
      console.log("getTemplates params:", params); 
      console.log(query, params);
      const res = await ApiRequest.post("/db/fetchData", { query, params });
      console.log("getTemplates res:", res);
      if (res && Array.isArray(res) && res.length > 0) {
        set((state) => ({
          header: { ...state.header, templates: res },
        }));
      }
      offLoading.call(this);

      return Array.isArray(res) ? res : [];
    },

    channels: [],
    selectedChannel: {},
    selectedChannelName: "",
    selectedPhone: "",
    setSelectedChannel: (data) =>
      set((state) => ({
        header: { ...state.header, selectedChannel: data },
      })),
    setSelectedChannelName: (channel) => {
      // 1) 스토어에 채널명 저장
      set((state) => {
        // initActivity 복제
        const act = { ...state.header.initActivity };
        // 기존에 있던 channelName arg 지우고
        act.arguments.execute.inArguments = act.arguments.execute.inArguments
          .filter(arg => !Object.prototype.hasOwnProperty.call(arg, "channelName"));
        // 새로 추가
        act.arguments.execute.inArguments.push({ channelName: channel });
        return {
          header: {
            ...state.header,
            selectedChannelName: channel,
            initActivity: act,
          },
        };
      });
    },

    setSelectedPhone: (data) =>
      set((state) => ({
        header: { ...state.header, selectedPhone: data },
      })),
    getChannels: async function () {
      // 공통 getChannels: 조직(org)정보를 사용
      const { org, onLoading, offLoading } = get().header;
      onLoading.call(this);
      const query = "SELECT * FROM channel";
      const res = await ApiRequest.post("/db/fetchData", { query });
      console.log("getChannels res:", res);
      if (res.recordset.length > 0) {
        set((state) => ({
          header: { ...state.header, channels: res.recordset },
        }));
      }
      offLoading.call(this);
    },

    logs: [],
    getLogs: async function () {
      console.log("getLogs called");
      const { journeyId } = get().header;
      const query = "SELECT * FROM logs WHERE journeyId = @journeyId";
      const res = await ApiRequest.post("/db/fetchData", {
        query,
        params: { journeyId },
      });
      if (res.recordset.length > 0) {
        set((state) => ({
          header: { ...state.header, logs: res.recordset },
        }));
      }
    },

    // MMS, 광고 여부 및 템플릿 편집 모드
    isMMS: false,
    setIsMMS: (data) =>
      set((state) => ({
        header: { ...state.header, isMMS: data },
      })),
    isAd: false,
    setIsAd: (data) =>
      set((state) => ({
        header: { ...state.header, isAd: data },
      })),
    selectedTemplate: {},
    setSelectedTemplate: (data) => {
      // 템플릿 선택 시 isMMS 초기화 및 initData 업데이트
      get().header.setIsMMS(false);
      console.log("Setting selectedTemplate:", data);
      set((state) => ({
        header: { ...state.header, selectedTemplate: data },
      }));
      get().mapper.setInitData();
    },

    // 날짜 포맷 생성
    setDate: (d) =>
      [
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getDay(),
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
      ].join("."),

    // 저장 플래그 및 템플릿 편집 모드
    save: false,
    isTemplateReadOnlyMode: false,
    isTemplateEditMode: false,
    isCloneMode: false,
    templateForEditMode: {},
    setTemplateEditMode: (isReadOnly, template, isEditMode, isCloneMode) => {
      console.log("Template for edit:", template, isReadOnly);
      set((state) => ({
        header: {
          ...state.header,
          templateForEditMode: template,
          isTemplateReadOnlyMode: isReadOnly,
          isTemplateEditMode: isEditMode,
          isCloneMode: isCloneMode,
        },
      }));
      get().header.openNewTemplateDialog();
    },

    // 새 템플릿/이미지 모달 오픈/클로즈
    newImageDialog: false,
    openNewImageDialog: () =>
      set((state) => ({ header: { ...state.header, newImageDialog: true } })),
    closeNewImageDialog: () =>
      set((state) => ({ header: { ...state.header, newImageDialog: false } })),
    newTemplateDialog: false,
    openNewTemplateDialog: () =>
      set((state) => ({ header: { ...state.header, newTemplateDialog: true } })),
    closeNewTemplateDialog: () =>
      set((state) => ({
        header: {
          ...state.header,
          newTemplateDialog: false,
          isCloneMode: false,
          isTemplateReadOnlyMode: false,
          isTemplateEditMode: false,
          templateForEditMode: {},
          selectedSingleImageData: null,
        },
      })),

    // 메시지 이미지 링크
    msg_img_link_url: "",
    setMsgImgLinkUrl: (url) =>
      set((state) => ({
        header: { ...state.header, msg_img_link_url: url },
      })),
  },

  // ---------------------------------------------------------------------------
  // preview 관련 상태 및 메서드
  // ---------------------------------------------------------------------------
  preview: {
    content: "Preview Content",
    setContent: (content) =>
      set((state) => ({ preview: { ...state.preview, content } })),
    isVar: false,
    setIsVar: (data) =>
      set((state) => ({ preview: { ...state.preview, isVar: data } })),
    variabledContent: "",
    page: 0,
    setPage: (data) =>
      set((state) => ({ preview: { ...state.preview, page: Number(data) } })),
    setVariabledContent: (data) =>
      set((state) => ({ preview: { ...state.preview, variabledContent: data } })),
    variabledContents: [],
    setVariabledContents: (data) =>
      set((state) => ({
        preview: {
          ...state.preview,
          variabledContents: data,
          ...(data.length > 0 && { variabledContent: data[0] }),
        },
      })),
    open: false,
    setOpen: (data) =>
      set((state) => ({ preview: { ...state.preview, open: data } })),
    variableSwitchFlag: false,
    setVariableSwitchFlag: (data) =>
      set((state) => ({
        preview: { ...state.preview, variableSwitchFlag: data },
      })),
    phoneMessageSwitchFlag: false,
    setPhoneMessageSwitchFlag: (data) =>
      set((state) => ({
        preview: { ...state.preview, phoneMessageSwitchFlag: data },
      })),

    // 로딩, 에러, 성공 상태
    loading: false,
    setLoading: (data) =>
      set((state) => ({ preview: { ...state.preview, loading: data } })),
    error: null,
    setError: (data) =>
      set((state) => ({ preview: { ...state.preview, error: data } })),
    success: false,
    setSuccess: (data) =>
      set((state) => ({ preview: { ...state.preview, success: data } })),
  },

  // ---------------------------------------------------------------------------
  // mapper 관련 상태 및 메서드
  // ---------------------------------------------------------------------------
  mapper: {
    defields: [],
    setDefields: (data) =>
      set((state) => ({ mapper: { ...state.mapper, defields: data } })),
    sendTarget: { value: "", type: "" },
    setSendTarget: (data) =>
      set((state) => ({ mapper: { ...state.mapper, sendTarget: data } })),
    datas: [],
    setDatas: (data) =>
      set((state) => ({ mapper: { ...state.mapper, datas: data } })),
    contacts: [],
    getContacts: async () => {
      const headData = get().header;
      const contact_res = await ApiRequest.post("/channel/getRowData", {
        extendId: headData.extensionId
        // baseUrl: headData.org.baseUrl,
        // token: headData.token,
      });
      console.log("Contact data fetched:", contact_res);
      if (contact_res.items && contact_res.items.length > 0) {
        await set((state) => ({
          mapper: {
            ...state.mapper,
            contacts: contact_res.items.map((c) => ({
              ...c.keys,
              ...c.values,
            })),
          },
        }));
      }
    },

    // Mapping 관련 로직 (DB 저장 및 initData 설정)
    setMapping: async () => {
      const { selectedChannelName, selectedTemplate, actId, extensionId, org, journeyId, interactionId, selectedChannel } = get().header;
      console.log("setMapping called", { selectedChannelName, actId });
      const mappingData = get().mapper;
      const query = "SELECT * FROM mapping WHERE eventId = @inputId";
      const check_res = await ApiRequest.post("/db/fetchData", { query, params: { inputId: actId, channelName: selectedChannelName } });
      console.log("Existing mapping data fetched:", check_res);
      const res_length = check_res.length || 0;

      mappingData.datas = [
        { name: "selectedChannelName", value: selectedChannelName, type: "string", context: "template" },
        { name: "selectedTemplate", value: selectedTemplate.msg_no, type: "string", context: "template" },
      ];
      console.log("Mapping data to save:", mappingData.datas);

      const target = {
        tableName: "mapping",
        data: {
          eventId: actId || "",
          mapping: JSON.stringify(mappingData.datas) || "",
          templateId: selectedTemplate.msg_no,
          channelCode: selectedChannel.channelCode || "",
          imageCode: "",
          // extendId: extensionId || "",
          ismms: get().header.isMMS || 0,
          adFlag: get().header.isAd || 0,
          journeyId: journeyId || "",
          versionId: interactionId || "",
          recipientMapping: JSON.stringify(mappingData.sendTarget) || "",
          organizationId: org.id,
        },
        params: { channelName: selectedChannelName },
        filter: { eventId: actId || "" },
      };

      // ★ 업데이트 시에는 extendId가 있을 때만 포함 (없으면 기존 값 보존)
      if (extensionId) {
        target.data.extendId = extensionId;
      }

      console.log("Target data for mapping:", target);
      const res = await ApiRequest.post(
        res_length > 0 ? "/db/updateData" : "/db/insertData",
        target
      );
      console.log("Mapping data saved:", res);
      set((state) => ({
        header: { ...state.header, save: true, target },
      }));
    },

    // initData 설정: 템플릿의 변수 추출 및 기본 데이터 설정
    setInitData: () => {
      const selectedTemplate = get().header.selectedTemplate;
      console.log("setInitData called", selectedTemplate);
      if (selectedTemplate && Object.keys(selectedTemplate).length > 0) {
        set((state) => ({
          mapper: { ...state.mapper, initData: selectedTemplate },
        }));
        // isAd 상태 설정
        if (["FC", "FL"].includes(selectedTemplate.templateMessageType)) {
          set((state) => ({
            header: { ...state.header, isAd: true },
          }));
        } else {
          set((state) => ({
            header: { ...state.header, isAd: false },
          }));
        }
        // 템플릿 내용에서 변수 추출
        const parseTemplateVariables = (template) => {
          const content = template.templateContent || "";
          const matches = content.match(/#\{[^}]+\}/g) || [];
          let labels = matches.map((label) => ({
            value: label.slice(2, -1),
            context: "template",
          }));
          if (template.buttons) {
            const btnGroups = JSON.parse(template.buttons) || [];
            btnGroups.forEach((group) => {
              group.forEach((button) => {
                const btnMatches = button.name.match(/#\{[^}]+\}/g) || [];
                btnMatches.forEach((label) => {
                  labels.push({ value: label.slice(2, -1), context: "button" });
                });
              });
            });
          }
          // 중복 제거
          return labels.filter(
            (label, index, self) =>
              index === self.findIndex((l) => l.value === label.value && l.context === label.context)
          );
        };
        const variables = parseTemplateVariables(selectedTemplate);
        console.log("Parsed Variables:", variables);
        set((state) => ({
          mapper: {
            ...state.mapper,
            datas: variables.map((v) => ({
              name: v.value,
              value: "",
              type: "",
              context: v.context,
            })),
          },
        }));
      } else {
        console.warn("No selectedTemplate found to set initData.");
      }
    },

    // noContentFiles 상태 및 조회 함수
    noContentFiles: [],
    setNoContentFiles: (data) =>
      set((state) => ({ mapper: { ...state.mapper, noContentFiles: data } })),
    fetchNoContentFiles: async (msg_no) => {
      const { selectedChannelName } = get().header;
      if (!msg_no) {
        console.error("msg_no is required to fetch no_message_btn data.");
        set((state) => ({
          preview: { ...state.preview, error: "msg_no 필요합니다." },
        }));
        return;
      }
      const query =
        "SELECT btn_no, msg_no, btn_name, btn_url, btn_sort FROM no_message_btn WHERE msg_no = @msg_no order by btn_sort";
      const params = { msg_no, channelName: selectedChannelName };
      try {
        const response = await ApiRequest.post("/db/fetchData", { query, params });
        if (response) {
          set((state) => ({
            mapper: { ...state.mapper, noContentFiles: response },
          }));
        } else {
          set((state) => ({
            mapper: { ...state.mapper, noContentFiles: [] },
            preview: { ...state.preview, error: "데이터를 가져오지 못했습니다." },
          }));
        }
      } catch (error) {
        console.error("Error fetching no_message_btn data:", error);
        set((state) => ({
          mapper: { ...state.mapper, noContentFiles: [] },
          preview: { ...state.preview, error: "서버 오류" },
        }));
      }
    },

    // executeV2: 템플릿 실행 API 호출
    executeV2: async () => {
      console.log("executeV2 called");
      const { selectedTemplate, selectedChannelName, setMsgImgLinkUrl } = get().header;
      const { datas, contacts, noContentFiles } = get().mapper;
      const { setLoading, setError, setSuccess } = get().preview;
      setLoading(true);
      setError(null);
      setSuccess(false);
      const payload = {
        selectedChannelName,
        template: selectedTemplate,
        data: datas,
        contacts,
        noContentFiles,
        msg_img_link_url: selectedTemplate.msg_img_link_url,
      };
      try {
        const response = await ApiRequest.post("/template/execute_v2", payload);
        console.log("API Response:", response);
        setSuccess(true);
      } catch (err) {
        console.error("API Error:", err);
        setError(err.message || "API 호출 중 오류가 발생했습니다.");
      } finally {
        setLoading(false);
      }
    },

    queryMappingTable: async (actId) => {
      try {
        let channelName = get().header.selectedChannelName;
        const query = "SELECT * FROM mapping WHERE eventId = ?";
        const params = [actId, channelName];
        const result = await ApiRequest.post("/db/fetchData", { query, params });
        console.log("Mapping table query result:", result);
        return result;
      } catch (error) {
        console.error("Error querying mapping table:", error);
      }
    },

    applyMappingData: (mappingJson) => {
      try {
        const mappingData = JSON.parse(mappingJson);
        console.log("applyMappingData - parsed mapping:", mappingData);
        if (Array.isArray(mappingData)) {
          // selectedChannelName 복원
          const channelMapping = mappingData.find(item => item.name === "selectedChannelName");
          if (channelMapping && channelMapping.value) {
            get().header.setSelectedChannelName(channelMapping.value);
          }
          // selectedTemplate 복원: 이미 로드된 templates 배열에서 msg_no 기준으로 필터링
          const templateMapping = mappingData.find(item => item.name === "selectedTemplate");
          if (templateMapping && templateMapping.value) {
            // templates 배열은 header 또는 mapper에 있을 수 있습니다.
            const templates = get().header.templates || get().mapper.templates;
            if (templates && Array.isArray(templates)) {
              console.log('test----------------1');
              console.log('templates:', templates);
              console.log('test----------------2');
              const matchedTemplate = templates.find(t => t.msg_no == templateMapping.value);
              if (matchedTemplate) {
                get().header.setSelectedTemplate(matchedTemplate);
              } else {
                console.warn("No matching template found with msg_no:", templateMapping.value);
              }
            } else {
              console.warn("Templates array is not available.");
            }
          }
        }
      } catch (e) {
        console.error("Error in applyMappingData:", e);
      }
    },
    


  },

}));

export default useStore;
